import { render, staticRenderFns } from "./catalog.vue?vue&type=template&id=7e478f4a&scoped=true&"
import script from "./catalog.vue?vue&type=script&lang=js&"
export * from "./catalog.vue?vue&type=script&lang=js&"
import style0 from "./catalog.vue?vue&type=style&index=0&id=7e478f4a&prod&scoped=true&lang=css&"
import style1 from "./catalog.vue?vue&type=style&index=1&id=7e478f4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e478f4a",
  null
  
)

export default component.exports